/** Route params for {@link generatePath}: every `:name` segment of the pattern needs a value. */
export type PathParams = Record<string, string>

/**
 * Fills the `:name` segments of a route pattern, e.g. `('/tenant/:tenantId/pois', { tenantId: 'a b' })`
 * gives `/tenant/a%20b/pois`. Values are URL-encoded.
 *
 * VI: Thay `generatePath` của `react-router` (chỉ dùng đúng hàm này); app dùng TanStack Router để điều hướng. | EN: Replaces
 *   `react-router`'s `generatePath` (the only thing used from it); navigation itself runs on TanStack Router.
 *
 * @throws Error when a `:name` segment has no value, so a broken URL is never navigated to silently.
 */
export function generatePath(pattern: string, params: PathParams = {}): string {
  return pattern.replace(/:([A-Z_]\w*)/gi, (_segment, name: string) => {
    const value = params[name]
    if (value === undefined) {
      throw new Error(`generatePath: missing value for ":${name}" in "${pattern}"`)
    }
    return encodeURIComponent(value)
  })
}
